export default __webpack_public_path__ + "static/media/similac900.816ee0ab.jpg";